import helperFunctions from "./helper-functions";
import resolutionCatalogModel from "@/store/orm-axios/models/ResolutionCatalog";
import resolutionModel from "@/store/orm-axios/models/Resolution";
import resolutionCatalogTagModel from "@/store/orm-axios/models/ResolutionCatalogTag";
import tagModel from "@/store/orm-axios/models/Tag";
let eventSource;

const resolutionCatalogIRI = "/resolution_catalogs/";
const resolutionIRI = "/resolutions/";
const resolutionCatalogTagIRI = "/resolution_catalog_tags/";
const tagIRI = "/tags/";

export default {
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initResolutionCatalogMercure();
      }
    },
  },
  created() {
    this.initResolutionCatalogMercure();
  },
  destroyed() {
    eventSource.close();
  },
  methods: {
    async initResolutionCatalogMercure() {
      if (!this.isAuthenticatedForMercure && this.isDesktop) {
        await helperFunctions.loginWebFromDesktop();
      }

      if (eventSource) eventSource.close();

      const topics = [
        `${resolutionCatalogIRI}{id}`,
        `${resolutionIRI}{id}`,
        `${resolutionCatalogTagIRI}{id}`,
        `${tagIRI}{id}`,
      ];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(resolutionCatalogIRI)) {
          model = resolutionCatalogModel;
        } else if (eventData["@id"].includes(resolutionIRI)) {
          model = resolutionModel;
        } else if (eventData["@id"].includes(resolutionCatalogTagIRI)) {
          model = resolutionCatalogTagModel;
        } else if (eventData["@id"].includes(tagIRI)) {
          model = tagModel;
        }

        helperFunctions.modifyInStore(eventData, model);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
